











































import { defineComponent, ref, computed } from "@vue/composition-api";
import * as OpsAPI from "@/services/api/ops";
import * as StudyAPI from "@/services/api/studies";
import { Study } from "@/psychlab/types";
import * as AppModal from "@/AppModal";
import { FoldoutCard, Heading, Container, Divider, TipIcon } from "@ui"
import { useTranslate } from "@lang"
import { getConfig } from "@config"

type Dictionary<T> = { [k:string]:T }

export default defineComponent({
	components: {
		FoldoutCard,
		Heading,
		Container,
		Divider,
		TipIcon,
	},
	setup(_, context) {
		// state
		const foldoutState = ref<Dictionary<boolean>>({});
		const study = ref<Study>();
		// computed
		const routeId = computed(() => context.root.$route.params["groupId"]);

		const { translate } = useTranslate();


		const showAdvanced = computed(() => {
			const cfg = getConfig();
			return cfg.canRebuildSessions || cfg.canDeleteStudies;
		})


		const toggleFoldout = (name: string) => {
			const d = foldoutState.value;
			d[name] = !Boolean(d[name]);
			foldoutState.value = JSON.parse(JSON.stringify(d));
		};

		const openBlueprintRoute = () => {
			if (!study.value) {
				return;
			}
			context.root.$router.push({
				name: "studies",
				params: {  },
			});
		};

		const rebuildSessions = async () => {
			try {
				await OpsAPI.rebuildSessionState({ group: routeId.value });
				console.log("Rebuilt sessions.");
			} catch (err) {
				console.error(err.message);
			}
		};

		const rebuildChannels = async () => {
			try {
				await OpsAPI.rebuildDataChannels({ study: routeId.value });
				console.log("Rebuilt channels.");
			} catch (err) {
				console.error(err.message);
			}
		};

		const deleteStudy = async () => {
			// if (!confirmModal.value) { return; }
			AppModal.confirm(
				{
					title: translate("studies.action.deleteStudy"),
					description: translate("prompts.message.irreversible"),
					variant:"danger",
					okText:translate("prompts.action.understood"),
					cancelText:translate("prompts.action.cancel")
				},
				async () => {
					try {
						await StudyAPI.deleteStudy(routeId.value);
						openBlueprintRoute();
					} catch (err) {
						console.log(err);
					}
				},
			);
		};

		const init = async () => {
			try {
				study.value = await StudyAPI.getStudy(routeId.value);
			} catch (err) {
				console.log(`Error loading study, id:'${routeId.value}'`);
			}
		};

		const runOperation = (name: string) => {
			switch (name) {
				case "rebuild-sessions":
					rebuildSessions();
					break;
				case "rebuild-channels":
					rebuildChannels();
					break;
				case "delete-study":
					deleteStudy();
					break;
			}
		};

		const ops = computed(() => {

			const cfg = getConfig();

			const foldouts: FoldoutContent[] = [];

			if(cfg.canRebuildSessions){
				foldouts.push({
					name: "rebuild-sessions",
					icon: "mdi.refresh",
					title: translate("studies.action.rebuildSessions"),
					variant: "info",
					content: translate("studies.message.onRebuildSessions"),
					buttonText: translate("studies.action.rebuildSessions"),
				});
			}

			if(cfg.canDeleteStudies){
				foldouts.push({
					name: "delete-study",
					icon: "mdi.trash-can",
					title: translate("studies.action.deleteStudy"),
					variant: "danger",
					content: translate("studies.message.onDeletingStudy"),
					buttonText: translate("studies.action.deleteStudy"),
				})
			}

			return foldouts;


		});

		init();

		return {
			foldoutState,
			ops,
			showAdvanced,
			toggleFoldout,
			rebuildSessions,
			rebuildChannels,
			deleteStudy,
			runOperation,
			translate,
		};
	},
});

type FoldoutContent = {
	name: string;
	icon: string;
	title: string;
	variant: string;
	buttonText: string;
	content: string;
};


